class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]') || this.querySelector('button[data-search-clear]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }

    if (this.resetButton && this.resetButton.hasAttribute('data-search-clear')) {
      this.resetButton.addEventListener('click', (event) => {
        event.preventDefault();
        if (this.input && this.input.form) {
          this.input.form.dispatchEvent(new Event('reset', { bubbles: true, cancelable: true }));
        }
        if (this.resetButton.hasAttribute('data-search-prompt-on-clear')) {
          const wrap = this.resetButton.closest('.query-box_container_input-container');
          if (wrap) {
            wrap.classList.add('search-input-prompt');
          }
          requestAnimationFrame(() => this.input?.focus());
        }
      });
    }

    if (this.input && this.resetButton?.hasAttribute('data-search-prompt-on-clear')) {
      this.input.addEventListener('input', () => {
        this.resetButton.closest('.query-box_container_input-container')?.classList.remove('search-input-prompt');
      });
    }
  }

  toggleResetButton() {
    if (!this.resetButton) return;
    if (this.resetButton.hasAttribute('data-always-visible-clear')) return;
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
